module.exports = __webpack_public_path__ + "img/classroom_default.ff59bdf0.png";